import React, { useEffect, useMemo, useState } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDCard from '../../../shared/antd/ANTDCard'
import { useFormInstanceFn, useWatchFn } from '../../../shared/antd/ANTDForm'
import { apiParams } from '../../../utils'
import { isEqual, keys, length } from '../../../utils/javascript'
import AddMoreForm from '../../common/presentation/AddMoreForm'
import { getAddressDataListApi, getTagListApi } from '../user.api'

const LocationChannel = ({ fieldName }) => {
  const { t } = useTranslations()
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [filteredCityList, setFilteredCityList] = useState([])
  const [channelList, setChannelList] = useState([])
  const form = useFormInstanceFn()
  const locationChannelRequestDtos = useWatchFn([...fieldName], form)

  const locationParentIdObj = useMemo(
    () =>
      cityList?.reduce((acc, item) => {
        if (item?.id) {
          acc[item?.id] = item?.parentId
        }
        return acc
      }, {}),
    [cityList],
  )

  useEffect(() => {
    getCityAPI({ type: 'STATE' })
    getLocationAPI({ type: 'CITY' })
    getChannelAPI({ type: 'CHANNEL_NAME' })
  }, [])

  useEffect(() => {
    if (
      length(locationChannelRequestDtos) &&
      length(keys(locationParentIdObj))
    ) {
      locationChannelRequestDtos.forEach((item, index) => {
        if (!item?.locationId) return
        if (isEqual(item?.stateId, locationParentIdObj?.[item?.locationId]))
          return

        form.setFieldValue(
          [...fieldName, index, 'stateId'],
          locationParentIdObj?.[item?.locationId],
        )
      })
    }
  }, [locationChannelRequestDtos, locationParentIdObj])

  const getCityAPI = async ({ type }) => {
    const params = apiParams({ params: { type } })
    const response = await getAddressDataListApi({ params })
    if (length(response?.data?.list)) {
      setStateList(response?.data?.list)
    }
  }

  const getLocationAPI = async ({ type }) => {
    const params = apiParams({ params: { type } })
    const response = await getAddressDataListApi({ params })
    if (length(response?.data?.list)) {
      setCityList(response?.data?.list)
    }
  }

  const getChannelAPI = async ({ type }) => {
    const response = await getTagListApi({ params: { type } })
    if (length(response?.data?.list)) {
      setChannelList(response?.data?.list)
    }
  }

  const selectedLocationIds =
    locationChannelRequestDtos?.map(item => item?.locationId) || []

  const availableCityList = cityList?.map(city => ({
    label: city?.name,
    value: city?.id,
    disabled: selectedLocationIds.includes(city.id),
  }))

  return (
    <ANTDCard title={t('user_LocationAndChannel')} className="add-user-card">
      <AddMoreForm
        formFieldAttributes={{
          locationId: {
            label: 'inv_Location',
            inputType: 'select',
            options: length(filteredCityList)
              ? filteredCityList
              : availableCityList,
            showSearch: true,
            filterOption: false,
            required: true,
            md: 8,
            xs: 24,
            onSearch: value => {
              const filterOption = availableCityList?.filter(opt =>
                opt?.label
                  ?.toLowerCase()
                  ?.includes(value?.trim()?.toLowerCase()),
              )
              setFilteredCityList(filterOption)
            },
          },
          channelIds: {
            label: 'user_Channel',
            inputType: 'select',
            mode: 'multiple',
            options: channelList?.map(v => ({
              label: v?.name,
              value: v?.id,
            })),
            required: true,
            md: 8,
            xs: 24,
          },
          stateId: {
            label: 'user_State',
            inputType: 'select',
            options: stateList?.map(v => ({
              label: v?.name,
              value: v?.id,
            })),
            required: true,
            disabled: true,
            md: 8,
            xs: 24,
          },
        }}
        listName={fieldName}
      />
    </ANTDCard>
  )
}

export default LocationChannel
